import { useState, useEffect, Fragment } from 'react';
import { getCdnPath } from '../../../utils/helpers';
import profileIcon from '../../../images/icons/ic-profile-circle-fill.svg';
import ticketRewardYellow from '../../../images/icons/ic-ticket-yellow.svg';
import thanksARamaGiveAway from '../../../images/30k-thanks-a-rama-giveaway.png';
import Button from '../Button/Button';
import allShowsLogo from '../../../images/verify-page-3shows.png';
import Stats from '../../Stats/Stats';
import rewardTicketBlack from '../../../images/icons/ic-ticket-black.svg';
import twolTicketLogo from '../../../images/digital-ticket-25wol-logo.png';
import pictionaryTicketLogo from '../../../images/digital-ticket-pictionary-logo.png';
import ppotTicketLogo from '../../../images/digital-ticket-ppot-logo.png';
import closeIcon from '../../../images/icons/ic-material-symbols-close.svg';
import { withCookies, useCookies } from 'react-cookie';
import createOrLoginHero from '../../../images/registration-modal-popup-hero.jpg';
// import createOrLoginHero from '../../../images/30k-unregistered-modal.jpg';
import parsePhoneNumber from 'libphonenumber-js'
import axios from '../../../axios-instance';

const Navigation = (props) =>{
    
    const [
        cookies,
        setCookie,
        removeCookie
    ] = useCookies(['A8FPVID', 'A8CFVLH', 'A8USRID', 'A8USRTKN', 'A8TKTCTR', 'A8PRESUBD', 'A8PROFDT']); 

    const [showCreateAccount, setShowCreateAccount] = useState(false);
    const [showVerifyPhoneNumber, setShowVerifyPhoneNumber] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [verificationCode, setVerificationCode] = useState(null);
    const [verificationError, setVerificationError] = useState(false);
    const [validCode, setValidCode] = useState(null);
    const [showTopBar, setShowTopBar] = useState(true);
    const [showProfile, setShowProfile] = useState(null);
    const [showLearnMore, setShowLearnMore] = useState(false);
    const [showTicketStats, setShowTicketStats] = useState(false);
    const [userToken, setUserToken] = useState(false);
    const [currentView, setCurrentView] = useState(null);
    const [previousView, setPreviousView] = useState(null);
    const [showCreateOrLogInModal, setShowCreateOrLogInModal] = useState(null);
    const [loginExperience, setLoginExperience] = useState(false);
    const [invalidNumber, setInvalidNumber] = useState(false);
    const [totalTickets, setTotalTickets] = useState(null);
    const [ticketsPerShow, setTicketsPerShow] = useState({
        twol : 0,
        pictionary : 0,
        ppot : 0
    });
    const [profileData, setProfileData] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [updatedFirstName, setUpdatedFirstName] = useState(null);
    const [updatedLastName, setUpdatedLastName] = useState(null);
    const [updatedEmail, setUpdatedEmail] = useState(null);
    const [updatedPrefillSubmissionData, setUpdatedPrefillSubmissionData] = useState(cookies.A8PRESUBD);
    const [agreeTermsAndConditions, setAgreeTermsAndConditions] = useState(false);
    const [verificationErrorMessage, setVerificationErrorMessage] = useState(null);
    const [delayedAutoRedirect, setDelayedAutoRedirect] = useState(null);
    const [blockCreateOrLoginModal, setBlockCreateOrLoginModal] = useState(false);

    const setView = (view) => {
        setPreviousView(currentView);
        setCurrentView(view);
        props.onViewSelection(view)
    }

    const mainContainerStyle = {
        height: "100%", 
        color: "white", 
        // backgroundImage: "url(" + process.env.REACT_APP_BACKGROUND_URL+")", 
        position: "fixed", 
        top:"0px", 
        width: "100%", 
        zIndex: "1",
        overflowY: "scroll"
    }

    const closeButton = <div style={{textAlign: "right", color: "white", paddingRight: "20px", marginTop: "20px"}} onClick={()=> setView(previousView)}>
        <img src={closeIcon} alt="Close button"/>
    </div>

    const learnMoreButton = <button 
        onClick={()=>{
            setView('learnMore')
            }} 
        style={{
            fontSize: "12px",
            fontFamily: "Inter",
            fontWeight: "500",
            textDecoration: "underline",
            marginBottom: "20px",
            background: "none",
            border: "none",
            color: "white"
        }}>Learn More
    </button>

    const requestOtp = () => {
        const parsedPhoneNumber = parsePhoneNumber(phoneNumber, 'US')

        if(!parsedPhoneNumber.isValid()) {
            console.log('Invalid number');
            setInvalidNumber(true);
            return;
        }

        axios.post(
            `/user/request-otp`, {phone_number : parsedPhoneNumber.number}, {headers: {
                'x-device-uuid': cookies.A8FPVID
              }}
        ).then((res)=>{
            console.log(res);
            if (res && res.data && res.data === 'pending') {
                setPhoneNumber(parsedPhoneNumber.number); 
                setView('verifyOtp')
            } else {

            }
        }).catch((err)=>{

        }).finally();

    }

    const giveAwayDescription = <div>        
        <p>Earn a <span style={{color: "#FD5"}}>digital ticket</span> each time you scan a QR code! The more you watch and play, the better chance you’ll have of being one of three lucky winners to take home</p>
        <p style={{
                textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25), 2px 2px 0px #208DD9",
                fontFamily: "Rubik",
                fontSize: "50px",
                marginTop: "0px",
                marginBottom: "0px",
                fontWeight: "800"
            }}>$10,000!</p>        
        </div>

    const enterPhoneNumber = <div style={mainContainerStyle}>
        <img src={thanksARamaGiveAway} alt='$30000 Thanks-a-rama giveaway!' style={{paddingTop: "20px"}}/>
        <div style={{width: "90%", paddingLeft: "20px", paddingRight: "20px"}}>
            {giveAwayDescription}
            {learnMoreButton}
            <div style={{
                backgroundColor: "white", 
                borderRadius: "20px",
                color: "black", 
                padding: "20px 15px 20px 15px",
                fontFamily: "Inter",
                lineHeight: "150%"
            }}>
                <h2 style={{
                    fontFamily: "Rubik",
                    fontSize: "24px",
                    fontWeight: "800",
                    marginTop: "0px"
                }}>{loginExperience ? 'Login' : 'Create Account'}</h2>
                <p style={{fontSize: "16px"}}>{loginExperience ? "Login with your phone number and we'll send you a text with your one-time password": 'Create an account to start earning digital tickets towards one of three grand prizes! Your account will also sync your progress across all three shows.'}</p>
                <form onSubmit={(e) => {e.preventDefault();requestOtp()}}>
                <input type="tel" pattern="[0-9]{10}" required placeholder={'Enter US phone number (i.e. "2223334444")'} onBlur={(event)=>setPhoneNumber(event.target.value)} style={{
                    borderRadius: "0px", 
                    border: "solid 1px #000",
                    width: "90%",
                    display: "flex",
                    height: "44px", 
                    paddingLeft: "5%",
                    paddingRight: "4%",
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    marginTop: "20px",
                    marginBottom: "20px",
                    alignItems: "center",
                    gap: "10px",
                    alignSelf: "stretch"
                }}/>
                {invalidNumber && <div style={{color:"red", marginBottom: "15px"}}>Please enter a valid US number</div>}
                <div style={{fontSize: "14px", textAlign: "left", marginBottom: "20px", display: "flex"}}>
                    <span><input type="checkbox" required defaultChecked={agreeTermsAndConditions} style={{height: "21px", width: "20px", marginRight: "10px", marginBottom: "40px"}} onChange={(event) => setAgreeTermsAndConditions(event.target.checked)}/></span>
                    <span style={{opacity: "0.65"}}>I agree to the <a href={process.env.REACT_APP_PRIVACY_POLICY_URL}>Privacy Policy</a>, <a href={process.env.REACT_APP_TERMS_OF_SERVICE_URL}>Terms & Conditions</a>, and <a href={process.env.REACT_APP_30K_GIVEAWAY_RULES_URL}>Sweepstakes Rules</a></span>
                </div>
                <Button 
                    style={{background: (phoneNumber && agreeTermsAndConditions) ? process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND : "#8A8A8A",}}
                    btnText={loginExperience ? 'Login' : 'Create Account'}/>
                </form>
                <button style={{textDecoration: "underline", backgroundColor: "white", border: "none", marginTop: "10px"}} onClick={() => setView(null)}>{loginExperience ? 'Skip Login Account For Now': 'Skip Create Account For Now'}</button>
            </div>
        </div>

    </div>

    const getProfileData = (updateView, user_id = null, user_token = null) => {

        const profileUserId = (user_id?? cookies.A8USRID);
        const profileUserToken = (user_token?? cookies.A8USRTKN);

        if(!profileUserId || !profileUserToken) {
            console.log('User profile could not be retrieved')
            return;
        }

        axios.get('user/' + profileUserId + '/pii', {
            headers : {
                "x-device-uuid" : cookies.A8FPVID,
                "Authorization" : "Bearer " + profileUserToken 
            }
        }).then((res) => {
            console.log(res)
            if(res && res.status === 200 && res.data ) {                
                setProfileData(res.data)
                setCookie('A8PROFDT', res.data, 
                    {
                        maxAge : 3600 * 24 * 30,
                        path: "/",
                        domain: process.env.REACT_APP_COOKIE_DOMAIN
                    })
                if(updateView) {
                    setView('profile')
                }                
            }
        })
    }

    const logInUser = () => {
        axios.post(
            `/user/login`, {
                login_method : "syndicated",
                external_id : phoneNumber,
                phone_number : phoneNumber,
                otp : verificationCode
            }, {headers: {
                'x-device-uuid': cookies.A8FPVID
              }}
        ).then((res)=>{
            console.log(res);
            if (res && res.data && res.data.access_token) {
                setPhoneNumber(null);
                setVerificationCode(null);
                setView(null)
                setUserToken(res.data.access_token);
                setCookie("A8USRTKN", res.data.access_token, {
                    maxAge : 3600 * 24 * 30,
                    path: "/",
                    domain: process.env.REACT_APP_COOKIE_DOMAIN
                }); // TODO: Read from env variable (30 days)
                setCookie("A8USRID", res.data.user_id, {
                    maxAge : 3600 * 24 * 30,
                    path: "/",
                    domain: process.env.REACT_APP_COOKIE_DOMAIN
                }); // TODO: Read from env variable (30 days)
                getProfileData(false, res.data.user_id, res.data.access_token);
                getTicketStats(res.data.access_token);
                props.onVerify(res.data.access_token);
            } 
        }).catch((err)=>{
            setVerificationErrorMessage('Your account could not get verified. Please try again.');    
        }).finally();        

    }

    const verifyPhoneNumber = <div style={mainContainerStyle}>
        <img src={thanksARamaGiveAway} alt='$30000 Thanks-a-rama giveaway!' style={{paddingTop: "20px"}}/>
        <img src={allShowsLogo} alt='Show logos' style={{paddingTop: "20px", marginBottom: "20px", width: "100%"}}/>
        <div style={{width: "90%", paddingLeft: "20px", paddingRight: "20px"}}>
            <div style={{
                backgroundColor: "white", 
                borderRadius: "20px",
                color: "black", 
                padding: "20px 15px 20px 15px",
                fontFamily: "Inter",
                lineHeight: "150%",
                fontSize: "16px"
            }}>
                <h2 style={{
                    fontFamily: "Rubik",
                    fontSize: "24px",
                    fontWeight: "800",
                    marginTop: "0px"
                }}>Verify Phone Number</h2>
                <p>We’ve sent you a text message with your 6-digit verifciation code to the phone number on you provided.</p>
                <p>Please enter the passcode below.</p>
                <form onSubmit={(e)=>{e.preventDefault(); logInUser()}}>
                <input type="text" required maxLength={6} pattern='[0-9]{6}' placeholder={'Enter 6-digit verification code'} onChange={(event)=>setVerificationCode(event.target.value)} style={{
                    borderRadius: "30px", 
                    border: "solid 1px #000",
                    width: "90%",
                    display: "flex",
                    height: "44px", 
                    paddingLeft: "5%",
                    paddingRight: "4%",
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    marginTop: "20px",
                    marginBottom: "20px",
                    alignItems: "center",
                    gap: "10px",
                    alignSelf: "stretch"
                }}/>
                {true && <p style={{color: "red"}}>{verificationErrorMessage}</p>}
                <p style={{fontSize: '14px', opacity: 0.65}}>Didn't get the code? Click below to get a new verification code</p>
                <button style={{textDecoration: "underline", backgroundColor: "white", border: "none", marginTop: "10px", marginBottom: "20px"}} onClick={(e) => {e.preventDefault(); requestOtp()}}>Resend code</button>
                <Button style={{
                    background: (verificationCode) ? process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND : "#8A8A8A",
                }} 
                btnText={'Verify'} />
                </form>
                <button style={{textDecoration: "underline", backgroundColor: "white", border: "none", marginTop: "10px"}} onClick={(e) => {e.preventDefault();setView(null)}}>{loginExperience ? 'Skip Login Account For Now': 'Skip Create Account For Now'}</button>
                </div>
        </div>

    </div>
    
    const invalidCode = <div style={mainContainerStyle}>
        <img src={thanksARamaGiveAway} alt='$30000 Thanks-a-rama giveaway!' style={{paddingTop: "20px"}}/>
        <img src={allShowsLogo} alt='Show logos' style={{paddingTop: "20px", marginBottom: "20px"}}/>
        <div style={{width: "90%", paddingLeft: "20px", paddingRight: "20px"}}>
            <div style={{
                backgroundColor: "white", 
                borderRadius: "20px",
                color: "black", 
                padding: "20px 15px 20px 15px",
                fontFamily: "Inter",
                lineHeight: "150%",
                fontSize: "16px"
            }}>
                <h2 style={{
                    fontFamily: "Rubik",
                    fontSize: "24px",
                    fontWeight: "800",
                    marginTop: "0px"
                }}>Something went wrong</h2>
                <p>Sorry, but there was a problem verifying the code you entered. Please re-enter your phone number to receive a new code:</p>
                <input type="phone" placeholder={'Phone Number'} style={{
                    borderRadius: "30px", 
                    border: "solid 1px #000",
                    width: "90%",
                    display: "flex",
                    height: "44px", 
                    paddingLeft: "5%",
                    paddingRight: "4%",
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    marginTop: "20px",
                    marginBottom: "20px",
                    alignItems: "center",
                    gap: "10px",
                    alignSelf: "stretch"
                }}/>
                <div style={{fontSize: "14px", textAlign: "left", marginBottom: "20px", display: "flex"}}>
                    <span><input type="checkbox" style={{height: "21px", width: "20px", marginRight: "10px", marginBottom: "40px"}}/></span>
                    <span style={{opacity: "0.65"}}>I agree to the <a href={process.env.REACT_APP_PRIVACY_POLICY_URL}>Privacy Policy</a>, <a href={process.env.REACT_APP_TERMS_OF_SERVICE_URL}>Terms & Conditions</a>, and <a href={process.env.REACT_APP_30K_GIVEAWAY_RULES_URL}>Sweepstakes Rules</a></span>
                </div>
                <Button btnText={'Create Account'} onClick={()=>{
                    // TODO: Request create account. Based on results hide the createAccount UX
                    //setPhoneNumber(1112223344);
                }}/>

                <button style={{textDecoration: "underline", backgroundColor: "white", border: "none", marginTop: "10px"}} onClick={() => setView(null)}>{loginExperience ? 'Skip Login Account For Now': 'Skip Create Account For Now'}</button>                    
                </div>
        </div>

    </div>

    const getScore = () => {
        axios.get('user/score', {
            params : {
                campaign_id : props.campaignId
            }, 
            headers : {
                "x-device-uuid" : cookies.A8FPVID,
                "Authorization" : "Bearer " + cookies.A8USRTKN 
            }
        }).then((res)=>{
            if(res && res.status === 200 && res.data) {
                setCookie('A8STATS', res.data, {
                    maxAge: 3600 * 24 * 30,
                    path: "/",
                    domain: process.env.REACT_APP_COOKIE_DOMAIN
                })
            }
        }).catch().finally()        
    }

    const topBar = <div style={{marginTop: "10px", width: "100%"}}>
        <img src={getCdnPath(process.env.REACT_APP_LOGO_URL)} alt="Application Logo" style={{width: "112px", height: "47px", marginLeft: "20px", marginBottom: "10px", float: "left"}} 
            onClick={()=>{
                setView(null)
            }}
        />
        {cookies.A8USRTKN ?
            <div style={{float: "right", marginRight: "20px", marginTop:"10px"}}>
                <img src={profileIcon} alt="Profile Icon" 
                    onClick={()=> {
                        getScore();
                        getProfileData(true)
                    }}/>
                <div style={{float:"right"}} 
                    onClick={()=>{
                        getTicketStats();
                        setView('ticketsStats')
                    }}>
                    <img src={ticketRewardYellow} alt="Ticket Icon" style={{marginLeft: "20px", marginRight: "10px"}}/>
                    <span style={{position: "relative", bottom: "6px", color: "rgb(255, 221, 85)", marginRight: "10px"}}>{cookies.A8TKTCTR?? 0}</span>
                </div>
            </div>
        : 
            <div style={{float: "right", marginRight: "20px", marginTop:"10px"}}>
                <span style={{position: "relative", bottom: "6px", color: "rgb(255, 221, 85)", marginRight: "10px"}} onClick={()=> {setPhoneNumber(null); setView('createAccount')}}>Create Account</span>
            </div>
        }
    </div>

    const updateProfileData = () => {
        axios.put('/user/' + cookies.A8USRID + '/pii', {
            first_name : updatedFirstName?? profileData.first_name,
            last_name : updatedLastName?? profileData.last_name,
            email : updatedEmail?? profileData.email,
            application_ids : [parseInt(process.env.REACT_APP_25WOL_APPLICATION_ID), parseInt(process.env.REACT_APP_PICT_APPLICATION_ID), parseInt(process.env.REACT_APP_PPOT_APPLICATION_ID)],
        }, {
            headers : {
                "x-device-uuid" : cookies.A8FPVID,
                "Authorization" : "Bearer " + cookies.A8USRTKN 
            }
        }).then((res) => {
            if(res && res.status === 200) {
                setCookie('A8PRESUBD', updatedPrefillSubmissionData, 
                {
                    maxAge : 3600 * 24 * 30,
                    path: "/",
                    domain: process.env.REACT_APP_COOKIE_DOMAIN
                })
                console.log('Updated profile')
            }
            

        }).catch().finally()
    }

    const needHelp = <div style={{
        backgroundColor: "white", 
        borderRadius: "20px",
        color: "black", 
        padding: "20px 15px 20px 15px",
        fontFamily: "Inter",
        lineHeight: "150%",
        marginTop: "20px"
    }}>
        <h2 style={{
            fontFamily: "Rubik",
            fontSize: "24px",
            fontWeight: "700",
            marginTop: "0px"
        }}>Need Some Help?</h2>
        <Button style={{color: "#12177B", backgroundColor: "#F1F1F1", borderRadius: "50px", marginTop: "20px"}} btnText="Check out the FAQ" onClick={() => window.open('/faq', '_self')}/>
        <Button style={{color: "#12177B", backgroundColor: "#F1F1F1", borderRadius: "50px", marginTop: "20px"}} btnText="Email us" onClick={() => window.location = 'mailto:' + process.env.REACT_APP_CUSTOMER_SUPPORT_EMAIL}/>
    </div>

    const profile = <div style={mainContainerStyle}>
        {topBar}
        <img src={thanksARamaGiveAway} alt='$30000 Thanks-a-rama giveaway!' style={{paddingTop: "20px"}}/>
        <Stats />
        <div style={{width: "90%", paddingLeft: "20px", paddingRight: "20px"}}>
            
            <div style={{
                backgroundColor: "white", 
                borderRadius: "20px",
                color: "black", 
                padding: "20px 15px 20px 15px",
                fontFamily: "Inter",
                lineHeight: "150%",
                marginTop: "20px"
            }}>
                <h2 style={{
                    fontFamily: "Rubik",
                    fontSize: "24px",
                    fontWeight: "700",
                    marginTop: "0px"
                }}>PROFILE INFO</h2>
                <p>Your profile info will be used for the {process.env.REACT_APP_NAME} At-Home Game and will automatically pre-fill the submission form.</p>
                <div style={{fontSize: "14px", textAlign: "left", marginBottom: "20px", display: "flex", }}>
                    <span><input type="checkbox" defaultChecked={cookies.A8PRESUBD === 'true'} disabled={!editMode} onChange={(event) => {setUpdatedPrefillSubmissionData(event.target.checked)}} style={{height: "21px", width: "20px", marginRight: "10px", marginBottom: "10px"}} /></span>
                    <span style={{opacity: "0.65"}}>Prefill Submission Data</span>
                </div>

                <input type="text" placeholder={'First Name'} defaultValue={profileData?.first_name} disabled={!editMode} onChange={(event) => setUpdatedFirstName(event.target.value)} style={{
                    borderRadius: "6px", 
                    border: "solid 1px #B0B0B0",
                    width: "90%",
                    display: "flex",
                    height: "44px", 
                    paddingLeft: "5%",
                    paddingRight: "4%",
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    marginBottom: "10px",
                    alignItems: "center",
                    gap: "10px",
                    alignSelf: "stretch"
                }}/>
                <input type="text" placeholder={'Last Name'} defaultValue={profileData?.last_name} disabled={!editMode} onBlur={(event) => setUpdatedLastName(event.target.value)} style={{
                    borderRadius: "6px", 
                    border: "solid 1px #B0B0B0",
                    width: "90%",
                    display: "flex",
                    height: "44px", 
                    paddingLeft: "5%",
                    paddingRight: "4%",
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    marginBottom: "10px",
                    alignItems: "center",
                    gap: "10px",
                    alignSelf: "stretch"
                }}/>
                <input type="email" patterm={''} placeholder={'Email Address'} defaultValue={profileData?.email} disabled={!editMode} onBlur={(event) => setUpdatedEmail(event.target.value)} style={{
                    borderRadius: "6px", 
                    border: "solid 1px #B0B0B0",
                    width: "90%",
                    display: "flex",
                    height: "44px", 
                    paddingLeft: "5%",
                    paddingRight: "4%",
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    marginBottom: "10px",
                    alignItems: "center",
                    gap: "10px",
                    alignSelf: "stretch"
                }}/>
                <input type="text" placeholder={'Phone Number'} value={profileData?.phone_number} disabled style={{
                    borderRadius: "6px", 
                    border: "solid 1px #B0B0B0",
                    width: "90%",
                    display: "flex",
                    height: "44px", 
                    paddingLeft: "5%",
                    paddingRight: "4%",
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    marginTop: "0px",
                    marginBottom: "0px",
                    alignItems: "center",
                    gap: "10px",
                    alignSelf: "stretch",
                    backgroundColor: "#F0F0F0"
                }}/>
                <p style={{color: "#B6B6B6", fontSize: "12px", fontWeight: "500", marginTop: "3px"}}>Phone number cannot be changed.</p>

                <Button btnText={editMode ? 'Update' : 'Edit'} onClick={()=>{
                    // TODO: Request create account. Based on results hide the createAccount UX
                    if(editMode) {
                        updateProfileData(); 
                        setEditMode(false);
                    } else {
                        setEditMode(true);
                    }
                    
                }}/>
            </div>

            {needHelp}

            <div style={{
                backgroundColor: "white", 
                borderRadius: "20px",
                color: "black", 
                padding: "20px 15px 20px 15px",
                fontFamily: "Inter",
                lineHeight: "150%",
                marginTop: "20px",
                marginBottom: "20px"
            }}>
                <h2 style={{
                    fontFamily: "Rubik",
                    fontSize: "24px",
                    fontWeight: "700",
                    marginTop: "0px"
                }}>REMOVE ACCOUNT</h2>

                <p>If you would like to remove your account, please consider that all your digital tickets, trivia game history, and profile details will be permanently removed.</p>
                <Button btnText={'Delete Account'} style={{color: "#12177B", backgroundColor: "#F1F1F1", borderRadius: "50px"}} onClick={()=>{
                    if(!window.confirm("Are you sure you want to delete your account?")) {
                        return;
                    }

                    axios.delete('/user/' + cookies.A8USRID, 
                        { 
                            headers : {
                                "x-device-uuid" : cookies.A8FPVID,
                                "Authorization" : "Bearer " + (cookies.A8USRTKN),
                                "content-type" : "application/json"
                            },
                            data : {
                                application_ids : [parseInt(process.env.REACT_APP_25WOL_APPLICATION_ID), parseInt(process.env.REACT_APP_PICT_APPLICATION_ID), parseInt(process.env.REACT_APP_PPOT_APPLICATION_ID)],
                            }

                        }
                    ).then((res) => {
                        if(res && res.status === 200) {
                            removeCookie('A8FPVID');
                            removeCookie('A8CFVLH');
                            removeCookie('A8USRID');
                            removeCookie('A8USRTKN');
                            removeCookie('A8TKTCTR');
                            removeCookie('A8PRESUBD');                        
                            setView(null);
                        }
                        props.onDeleteAccount();
                    }).catch().finally()
                }}/>
            </div>
        </div>

    </div>



    const ticketStats = <div style={mainContainerStyle}>
        {topBar}
        {/* <div style={{color: "white", justifyContent: "left", marginBottom: "10px", width: "100%", paddingLeft: "45px", display: "flex"}}>
            Go Back
        </div> */}
        
        <img src={thanksARamaGiveAway} alt='$30000 Thanks-a-rama giveaway!' style={{paddingTop: "10px"}}/>
        <div style={{width: "90%", paddingLeft: "20px", paddingRight: "20px"}}>
            {giveAwayDescription}
            {learnMoreButton}
            <div style={{backgroundColor: "rgba(255, 255, 255, 0.15)", paddingTop: "10px", borderRadius: "20px"}}>
                <p style={{fontFamily: "Rubik", fontSize: "24px", fontWeight: "700", color: "#FD5", textShadow: "0px 2px 4px rgba(0, 0, 0, 0.50)", marginBottom: "15px"}}>TOTAL DIGITAL TICKETS</p>
                    <div style={{
                        fontSize: "24px",
                        lineHeight: "20px",
                        backgroundColor:"#FFDD55", 
                        borderRadius: "60px",
                        display: "flex",
                        width: "auto",
                        maxWidth: "160px",
                        height: "40px",
                        padding: "0px 10px",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px",
                        // alignSelf: "stretch",
                        marginLeft: "auto",
                        marginRight: "auto",
                        color: "black", 
                        marginBottom: "10px", 
                        fontWeight: "700"
                        }}>
                            <img style={{width: "30px", height: "30px"}} src={rewardTicketBlack} alt='Reward ticket black'/>{totalTickets}
                    </div>

                    <div style={{padding: "20px"}}>
                        <div style={{
                            display: "flex",
                            width: "100%",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            alignSelf: "stretch"
                        }}>
                            <img src={twolTicketLogo} style={{height: "40px"}} alt='25WOL logo' onClick={() => window.open('https://25words.com/#wheretowatch', '_blank')}/>
                            
                            <div >
                                <img src={ticketRewardYellow} />
                                <span style={{position: "relative", bottom: "6px", color: "rgb(255, 221, 85)", marginLeft: "10px", marginRight: "10px"}}>{ticketsPerShow.twol}</span>
                            </div>
                    </div>

            </div>
            <hr style={{marginTop: "0px", marginBottom: "0px", backgroundColor: "#FFF", opacity: "0.1"}}/>
            <div style={{padding: "20px"}}>
                <div style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    alignSelf: "stretch"
                }}>
                    <img src={pictionaryTicketLogo} style={{height: "40px"}} alt='Pictionary logo' onClick={() => window.open('https://pictionaryontv.com/#where-to-watch', '_blank')}/>
                    
                    <div >
                        <img src={ticketRewardYellow} />
                        <span style={{position: "relative", bottom: "6px", color: "rgb(255, 221, 85)", marginLeft: "10px", marginRight: "10px"}}>{ticketsPerShow.pictionary}</span>
                    </div>
                </div>

        </div>
        <hr style={{marginTop: "0px", marginBottom: "0px", backgroundColor: "#FFF", opacity: "0.1"}}/>
        <div style={{padding: "20px"}}>
                <div style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    alignSelf: "stretch"
                }}>
                    <img src={ppotTicketLogo} style={{height: "40px"}} alt='Person, Place or Thing logo' onClick={() => window.open('https://personplaceorthingontv.com/#wheretowatch', '_blank')}/>
                    
                    <div >
                        <img src={ticketRewardYellow} />
                        <span style={{position: "relative", bottom: "6px", color: "rgb(255, 221, 85)", marginLeft: "10px", marginRight: "10px"}}>{ticketsPerShow.ppot}</span>
                    </div>
                </div>

        </div>                            
            </div>



        </div>

        <div style={{opacity: "0.5", fontSize: "14px", marginTop: "5px"}}>
            Tap a show to look up where to watch.
        </div>
    </div>    

    const learnMore = <div style={mainContainerStyle}>
        {/* {topBar} */}
        {closeButton}
        
        <img src={thanksARamaGiveAway} alt='$30000 Thanks-a-rama giveaway!' style={{marginTop: "10px", marginBottom: "20px"}}/>
        <div style={{padding: "20px", background: "rgba(255, 255, 255, 0.15)"}}>
            <h2 style={{fontFamily: "Rubik", fontSize: "30px", fontWeight: "700"}}>HOW DO I EARN <br/><span style={{color: "#FD5"}}>DIGITAL TICKETS</span>?</h2>
            <ol style={{paddingInlineStart: "20px", textAlign: "left", fontSize: "16px"}}>
                <li style={{marginBottom: "20px"}}>Watch each episode of <b>25 Words or Less</b>, <b>Pictionary</b>, and <b>Person Place or Thing</b></li>
                <li style={{marginBottom: "20px"}}>Find and <b>scan</b> the QR Code on each episode (there are a few!)</li>
                <li style={{marginBottom: "20px"}}>Each <b>scan</b> will earn you <span style={{color: "#FD5"}}>1 digital ticket</span> towards the grand prize</li>
            </ol>
            <p style={{fontWeight: "700", marginTop: "30px"}}>
                The more tickets you collect, the greater your chances of snagging one of three ultimate grand prizes!
            </p>
            <div style={{fontSize: "12px", fontWeight: "500", marginTop: "30px", opacity: 0.5, paddingLeft: "15px", paddingRight: "15px"}}>    
                    <button onClick={()=>window.open(process.env.REACT_APP_30K_GIVEAWAY_RULES_URL)} style={{background: "none", border: "none", textDecoration: "underline", color: "#fff"}}>See Official Rules for more details</button>
                    <p>$30K Thanks-A-Rama Giveaway Sweepstakes Period  runs September 9, 2024 thru May 30, 2025.</p>
                    <p>You must log in to your account or <span style={{}}>create an account</span> to earn digital tickets. </p>
                </div>
        </div>
    </div>    

    const backdrop = <div style={{
        position: "fixed",
        top: 0,
        background: "rgb(0,0,0,0.5)",
        height: "100%",
        width: "100%",
        zIndex: 2,
        overflow: "hidden"
    }}></div>
    
    const createOrLogInModal = <Fragment>
        {/* {backdrop} */}
        <div style={{
            position: "fixed",
            top: "0",
            marginLeft: "0",
            marginRight: "0",
            height: "100%",
            width: "100%",
            backgroundColor: "white",
            zIndex: 3,
            // borderRadius: "20px",
            color: "black",
            fontWeight: "500",
            overflowY: "scroll"
        }}>
        <img src={createOrLoginHero} style={{width: "100%"}} alt='Login or Create Account hero'/>
        <div style={{padding: "0px 20px 20px 20px", lineHeight: "150%", fontSize: "16px"}}>
            <p>Earn a digital ticket each time you scan a QR code! The more you watch and play, the better chance you’ll have of being one of three lucky winners to take home</p>
            <p style={{
                textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25), 2px 2px 0px #208DD9",
                fontFamily: "Rubik",
                fontSize: "50px",
                marginTop: "0px",
                marginBottom: "0px",
                fontWeight: "800"
            }}>$10,000!</p>                    
            <p style={{paddingBottom: "10px"}}>That’s not all, when you play the <br/>{process.env.REACT_APP_NAME_ABBREVIATED} At-Home Game, you can also win daily prizes!</p>
            <Button btnText="Create Account" onClick={() => {
                setView('createAccount');
                setShowCreateOrLogInModal(false);
            }}/>
            <p style={{color: "#171C8F", fontWeight: "700", marginBottom: "10px", fontSize: "16px"}}>Already have an account? <span style={{textDecoration: "underline"}} onClick={()=>{
                setShowCreateOrLogInModal(false);
                setLoginExperience(true);
                setView('loginAccount');
            }}>Log In</span></p>
            <button onClick={() => {
                    setShowCreateOrLogInModal(false);
                    setView(null)
                }}
                style={{
                    color: "#707070",
                    textAlign: "center",
                    fontFamily: "Rubik",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "20px", 
                    textDecoration: "underline",
                    border: "none",
                    background: "none",
                    marginBottom: "20px"
                }}>Skip for Now</button> 
            <p style={{color: "black", fontSize: "12px", fontWeight: "500", lineHeight: "150%", marginTop: "5px", opacity: "0.5", paddingLeft: "40px", paddingRight: "40px"}}>Account is required to earn digital tickets, but is not required to play.</p>
        </div>
        </div>

    </Fragment>

    const getTicketStats = (token = null) => {        
        axios.get('user/rewards', {
            params : {
                application_ids : [parseInt(process.env.REACT_APP_25WOL_APPLICATION_ID), parseInt(process.env.REACT_APP_PICT_APPLICATION_ID), parseInt(process.env.REACT_APP_PPOT_APPLICATION_ID)],
                group_by : 'application_id'
            },
            headers : {
                "x-device-uuid" : cookies.A8FPVID,
                "Authorization" : "Bearer " + (token?? cookies.A8USRTKN),
                "content-type" : "application/json"
            }
        }).then((res)=>{
            if(res.status === 200) {
                let grandTotalTicketCounter = 0;
                let ticket25WOL = 0;
                let ticketPict = 0;
                let ticketPpot = 0;

                res.data.forEach(element => {
                    if(element.application_id === parseInt(process.env.REACT_APP_25WOL_APPLICATION_ID)) {
                        ticket25WOL = parseInt(element.value);
                    } else if(element.application_id === parseInt(process.env.REACT_APP_PICT_APPLICATION_ID)) {
                        ticketPict = parseInt(element.value);
                    } else if(element.application_id === parseInt(process.env.REACT_APP_PPOT_APPLICATION_ID)) {
                        ticketPpot = parseInt(element.value);
                    }                                            
                    grandTotalTicketCounter += parseInt(element.value)    
                });
                
                setCookie('A8TKTCTR', grandTotalTicketCounter, 
                    {
                        maxAge : 3600 * 24 * 30,
                        path: "/",
                        domain: process.env.REACT_APP_COOKIE_DOMAIN
                    }
                )
                setTotalTickets(grandTotalTicketCounter);
                setTicketsPerShow({
                    twol : ticket25WOL,
                    pictionary : ticketPict,
                    ppot : ticketPpot
                });
                
            }
            
        })
    }

    useEffect(() => {
        console.log('use effect call');

        let delayedAutoRedirectEnabled = false;
        for(const element of props.tags) {
            if(element.name === 'delayed-auto-redirect') {
                console.log('setting autoredirect');
                delayedAutoRedirectEnabled = true;
                setDelayedAutoRedirect(true);
            } if (element.name === 'no-registration-modal') {
                setBlockCreateOrLoginModal(true)
            }

        }        
        if(delayedAutoRedirectEnabled) {
            console.log('delayed autoredirect enabled')        
        }else if(!blockCreateOrLoginModal && !cookies.A8USRTKN) {            
            setTimeout(()=>{setShowCreateOrLogInModal(true); props.onViewSelection(true)}, 3000)
        } else {            
            getTicketStats()
        }
    }, [])

    return ( 
        <div style={{overflowY: "hidden"}}>
            {currentView === 'createAccount' && enterPhoneNumber} 
            {currentView === 'verifyOtp' && verifyPhoneNumber} 
            {currentView === 'loginAccount' && enterPhoneNumber} 
            {currentView === 'profile' && profile}
            {currentView === 'ticketsStats' && ticketStats}
            {currentView === 'learnMore' && learnMore}            
            {!currentView && topBar}
            {showCreateOrLogInModal && !blockCreateOrLoginModal && createOrLogInModal}
        </div>

        
    )
}

export default Navigation;